module.exports = __webpack_public_path__ + "img/emoticon-nps-10-off.293b36b1.svg";